import { List, Grid, Chip, Avatar } from "@mui/material"
import { useAppSelector } from "../../../../../../../hooks/store-hooks";
import { useProjetosService } from "../../../../../../../../use-cases/geo-veles";

export const ProfissaoFilterPreview = () => {
  // State
  const { filtrosSelecionados } = useAppSelector((state) => state.projetos)
  // Hook
  const { removeProfissaoFilter } = useProjetosService()

  return (
    <>
      <List>
        <Grid container spacing={3}>
          {filtrosSelecionados?.profissao?.map((ocupacao, index) => {
            return (
              <Grid item key={index}>
                <Chip
                  label={ocupacao.familiadescricao ? ocupacao.familiadescricao.toUpperCase() : ''}
                  sx={{
                    height: 'auto',
                    '& .MuiChip-label': {
                      transition: '0.1s all',
                      display: 'block',
                      whiteSpace: 'normal',
                      padding: '10px 15px',
                      fontWeight: 'bold'
                    }
                  }}
                  color="primary"
                  onDelete={() => {
                    removeProfissaoFilter(ocupacao)
                  }}
                  avatar={
                    <Avatar sx={{
                      "&": {
                        transition: '0.1s all'
                      },
                      "&:hover": {
                        color: "secondary.main",
                        cursor: 'default'
                      }
                    }}>
                    </Avatar>
                  }
                />
              </Grid>
            )
          })}
        </Grid>
      </List >
    </>
  )
}